import React from "react";
import { Link } from "react-router-dom";
import "./Breadcrumb.css";

export const Breadcrumb = ({ children }) => (
  <div data-testid="breadcrumbs" className="Breadcrumb" children={children} />
);
export const BreadcrumbItem = ({ children, to, href, onClick }) => {
  return to ? (
    <Link className="BreadcrumbItem" to={to} children={children} />
  ) : href ? (
    <a className="BreadcrumbItem" href={href} children={children} onClick={onClick} />
  ) : (
    <div className="BreadcrumbItem" to={to} children={children} onClick={onClick} />
  );
};
